import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Divider
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import {
  MealInterface,
  MealWithCategoryInterface
} from '../../../../../../shared/type/mealsMenu.type';
import BadgeWithMessage from '../../../../../BadgeWithMessage/BadgeWithMessage';
import CustomChakraButton from '../../../../../CustomChakraButton/CustomChakraButton';
import IconComponent from '../../../../../IconComponent/IconComponent';
import { useAddEditMealPlan } from '../../MealPlan/AddEditMealPlan/useAddEdtiMealPlan';
import ChooseMonths from '../../../../../ChooseMonths/ChooseMonths';
import { MultipleSelect } from '../../../../../Forms/MultipleSelect/MultipleSelect';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  selectedMeals: MealInterface[];
}

const AddToMealPlan = ({ isOpen, onClose, selectedMeals }: Props) => {
  const [meals, setMeals] = useState<MealWithCategoryInterface[]>(
    selectedMeals.map((meal) => ({
      ...meal,
      categoryIds: [] // zamiast categoryId
    }))
  );
  const isAnyMealReadyForAssigne = meals.some((meal) => meal.categoryIds.length > 0);
  const {
    currentDate,
    setCurrentDate,
    formattedDate,
    getCategoryName,
    mealCategoriesToSelect,
    allergens,
    setMealFromBaseFormData,
    mealsForDay,
    uniqueCategories,
    handleDeleteMeal,
    handleAssignMealsFromBase
  } = useAddEditMealPlan();

  useEffect(() => {
    setMealFromBaseFormData(meals);
  }, [meals]);

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="70-vw" isCentered>
      <form onSubmit={() => console.log('submit')}>
        <ModalOverlay
          sx={{
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }}
        />
        <ModalContent>
          <ModalHeader className="flex">
            <div className="basis-5/12 flex flex-col text-grayLight-900 font-semibold text-lg border-r border-grayLight-200">
              <h2 className="font-semibold text-lg">Dodaj do jadłospisu</h2>
              <p className="text-grayLight-600 text-sm font-normal">
                Aby dodać jadłospis wybierz datę a następnie przypisz kategorie do wybranych dań.
              </p>
            </div>
            <div className="basis-7/12 flex items-center justify-between text-grayLight-700 font-semibold text-xl box-border border-l border-grayLight-200">
              <h2 className="font-semibold text-lg pr-spacing-3xl pl-spacing-3xl">
                Podgląd do jadłospisu
              </h2>
              <h2 className="font-semibold text-lg pr-spacing-3xl pl-spacing-3xl">
                {formattedDate || 'Data'}
              </h2>
            </div>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody className="flex">
            <div className="h-[700px] overflow-y-auto basis-5/12 border-r border-grayLight-200 flex flex-col gap-spacing-xl">
              <div className="flex flex-col gap-spacing-xs">
                <label className="text-sm font-medium text-grayLight-700">
                  Dzień obowiązywania jadłospisu
                </label>
                <div className="w-44">
                  <ChooseMonths
                    hideTodayButton={true}
                    setDate={setCurrentDate}
                    currentDate={currentDate}
                    mode="day"
                  />
                </div>
              </div>
              <div className="flex flex-col">
                {meals.map((meal) => (
                  <div className="flex flex-col gap-spacing-xl" key={meal.id}>
                    <div className="flex flex-col gap-spacing-xs">
                      <p className="text-lg font-semibold text-grayLight-900 uppercase">
                        {meal.name}
                      </p>
                      <p className="text-sm font-medium text-grayLight-600">{meal.description}</p>
                    </div>
                    <div className="flex justify-between gap-spacing-xl">
                      <div className="flex flex-col w-96">
                        <label className="text-sm font-semibold text-grayLight-700">
                          Przypisz kategorię*
                        </label>
                        <MultipleSelect
                          options={mealCategoriesToSelect}
                          selected={meal.categoryIds}
                          setSelected={(newCategoryIds) => {
                            setMeals((prevMeals) =>
                              prevMeals.map((m) =>
                                m.id === meal.id
                                  ? {
                                      ...m,
                                      categoryIds: newCategoryIds
                                    }
                                  : m
                              )
                            );
                          }}
                          placeholder="Wybierz kategorię"
                          fullWidth
                        />
                      </div>
                    </div>
                    <Divider className="bg-grayLight-200 mt-5 mb-5" />
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`basis-7/12 border-l border-grayLight-200 flex flex-col ${mealsForDay.length === 0 ? ' items-center justify-center' : ''}`}>
              {mealsForDay.length === 0 ? (
                <div className="flex flex-col items-center justify-center gap-spacing-xl">
                  <div>
                    <IconComponent iconName="cutlery" className="w-10 h-10" />
                  </div>
                  <p>Tu pojawi się lista dań dodanych do jadłospisu na dany dzień.</p>
                </div>
              ) : (
                <div className="p-spacing-3xl">
                  <ul className="list-disc ml-5 flex flex-col gap-spacing-4xl">
                    {uniqueCategories.map((categoryId) => {
                      if (!categoryId) return null;

                      return (
                        <li
                          key={categoryId}
                          className="text-lg font-semibold list-none text-grayLight-900">
                          <h3 className="text-lg font-semibold">
                            {getCategoryName(categoryId).charAt(0).toUpperCase() +
                              getCategoryName(categoryId).slice(1)}
                          </h3>
                          <ul className="flex flex-col gap-spacing-4xl">
                            {mealsForDay
                              .filter((meal) => meal.courseId === categoryId)
                              .map((meal) => (
                                <li
                                  key={meal.id}
                                  className="text-sm font-medium text-grayLight-700">
                                  <div className="flex flex-col gap-spacing-xs">
                                    <div className="flex justify-between border-b border-brand-300">
                                      <p className="font-normal text-sm text-grayLight-900 pt-spacing-xs pr-spacing-md pb-spacing-xs pl-spacing-md">
                                        {meal.name}
                                      </p>
                                      <button
                                        className="bg-transparent border-none"
                                        type="button"
                                        onClick={() => {
                                          if (!meal.id || !meal?.mealToDayId) return;
                                          handleDeleteMeal(meal?.mealToDayId || meal?.id);
                                        }}>
                                        <IconComponent iconName="xClose" className="w-3 h-3" />
                                      </button>
                                    </div>
                                    <p className="text-grayLight-600 pt-spacing-xs pr-spacing-md pb-spacing-xs pl-spacing-md">
                                      {meal.description}
                                    </p>
                                    <div className="flex gap-spacing-xs flex-wrap">
                                      {meal.allergenIds.map((allergenId) => {
                                        const allergen = allergens.find(
                                          (allergen) => allergen.id === allergenId
                                        );
                                        if (!allergen) return;
                                        return (
                                          <BadgeWithMessage
                                            tooltipLabel={allergen.name}
                                            key={
                                              allergen.id
                                            }>{`${allergen.formalNumber}`}</BadgeWithMessage>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter className="w-full flex justify-between gap-spacing-lg">
            <CustomChakraButton
              hierarchy="secondaryColor"
              size="lg"
              iconPosition="onlyText"
              buttonProps={{
                className: 'basis-5/12',
                type: 'button',
                onClick: () => onClose()
              }}>
              Zakończ
            </CustomChakraButton>
            <CustomChakraButton
              hierarchy="primary"
              iconPosition="left"
              icon="plus"
              size="lg"
              buttonProps={{
                onClick: () => handleAssignMealsFromBase(),
                type: 'button',
                disabled: !isAnyMealReadyForAssigne || meals.length === 0
              }}>
              Dodaj dania do jadłospisu
            </CustomChakraButton>
            <div className="basis-7/12"></div>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
};

export default AddToMealPlan;
